package com.vizio.redwolf.consent.api

import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.RetryConfig
import io.ktor.http.HttpStatusCode
import kotlinx.coroutines.delay
import kotlin.math.pow

private fun <T : Any> isConsentSuccess(result: T): Boolean {
    return result is ConsentResult.Success<*>
}

private fun <T : Any> getStatusCodeOrNull(result: T): Int? {
    val consentResult = result as? ConsentResult<*>
    return consentResult?.let {
        val responseHeaders = when (consentResult) {
            is ConsentResult.Success -> consentResult.headers
            is ConsentResult.Failed -> consentResult.headers
            is ConsentResult.Error -> consentResult.headers
            is ConsentResult.Timeout -> consentResult.headers
        }
        if (responseHeaders is ResponseHeaders.Valid) responseHeaders.statusCode else null
    }
}

internal suspend inline fun <T : Any> retryConsentRequest(retryConfig: RetryConfig?, block: () -> T): T {
    var result: T = block()
    var count = 0
    val statusCode = getStatusCodeOrNull(result)
    return if (isConsentSuccess(result) || statusCode == HttpStatusCode.Unauthorized.value
        || statusCode == HttpStatusCode.TooManyRequests.value || retryConfig == null
    ) {
        result
    } else {
        while (!isConsentSuccess(result) && count < retryConfig.retryAttempts) {
            val expInterval = (retryConfig.initialDelay * retryConfig.exponentialBase.toDouble().pow(count.toDouble())).toLong()
            delay(expInterval)
            result = block()
            count++
        }
        result
    }
}